import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IStockMovementFilter } from "../models/filters/stockMovementFilter";
import { IStockMovementForm } from "../models/forms/stockMovementForm";
import { IStockMovementPDTO } from "../models/dtos/stockMovementPDTO";
import { apiCallWithAuth } from "../helper/apiManager";
import { IArticleStockUnityMovementPDTO } from "../models/dtos/articlePDTO";

export default class StockMovementService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/StockMovement";

    protected static override  getUrlFilter<F extends IStockMovementFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.code != undefined)
                url += `&Code=${filter.code}`;
            if(filter.articleId != undefined)
                url += `&ArticleId=${filter.articleId}`;
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if(filter.unityId != undefined)
                url += `&UnityId=${filter.unityId}`;
            if(filter.way != undefined)
                url += `&Way=${filter.way}`;
        }
        
        return url;
    }

    public static async stockMovement(stockMovement: IStockMovementForm)
        {
            try {
                let result = await apiCallWithAuth(this.mainUrl + "/articlestockmovement", "post", stockMovement);
                return this.ReturnObject(result);
            } catch (err) {
                return this.ReturnError(err);
            }
        }

    public static override toDTO(obj:IStockMovementForm):IStockMovementPDTO {
        const dto = super.toDTO(obj) as IStockMovementPDTO;
        return dto;
    }
}